import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
    list: [],
    order: null,
    category: [],
    request: [],
    setting: {}
  },
  mutations: {
    initRequest (state) {
      state.request = []
    },
    addRequest (state, data) {
      const hasItem = state.request.filter(x => x.item === data.item).length > 0
      if (hasItem) {
        state.request = state.request.map(function (x) {
          return x.item === data.item ? data : x
        })
      } else {
        state.request.push(data)
      }
    },
    delRequest (state, data) {
      state.request = state.request.filter(x => x.item !== data.item)
    }
  },
  actions: {
    setAmenityData ({ state }, data) {
      state.list = data.list.map(x => x)
      state.category = data.category
      state.order = data.order || null
      state.setting = data.setting || {}
      return true
    },
    async getAmenity ({ dispatch }) {
      const file = 'amenity/amenity.json'
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=${API.SITE_INFO.site}&file=${file}`)
        dispatch('setAmenityData', res.data.message)
        return res.data.message
      } catch (ex) {
        console.log(ex.reponse)
        return false
      }
    }
  },
  getters: {
    getAmenityList: state => state.list,
    getAmenityOrder: state => state.order,
    getAmenityCategory: state => state.category,
    getAmenityRequest: state => state.request,
    getAmenitySetting: state => state.setting
  }
}
